import { Column, Entity, Index, PrimaryGeneratedColumn } from "typeorm";

@Index("estatus", ["estatus"], {})
@Entity("class")
export class ClassEntity {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("varchar", { name: "class", length: 100, default: () => "''" })
  class: string;

  @Column("varchar", { name: "estatus", length: 2, default: () => "'1'" })
  estatus: string;

  @Column("varchar", { name: "timestamp", length: 20, default: () => "''" })
  timestamp: string;
}
